import React from "react";
import styled from "styled-components";
// Assets (use your relevant icons here)
import RollerIcon from "../../assets/svg/Services/RollerIcon";
import MonitorIcon from "../../assets/svg/Services/MonitorIcon";
import BrowserIcon from "../../assets/svg/Services/BrowserIcon";
import CheckMark from "../../assets/svg/Checkmark";  // Assuming you have a CheckMark icon

export default function PricingTable({ icon, price, title, text, features, action }) {
  let getIcon;

  switch (icon) {
    case "roller":
      getIcon = <RollerIcon />;
      break;
    case "monitor":
      getIcon = <MonitorIcon />;
      break;
    case "browser":
      getIcon = <BrowserIcon />;
      break;
    default:
      getIcon = <RollerIcon />;
      break;
  }

  return (
    <Wrapper>
      <IconWrapper>{getIcon}</IconWrapper>
      <Price>{price}</Price>
      <Title>{title}</Title>
      <Description>{text}</Description>
      <FeatureList>
        {features.map((feature, index) => (
          <Feature key={index}>
            {feature.checked ? <Check /> : <div style={{ minWidth: "20px" }} />}
            {feature.name}
          </Feature>
        ))}
      </FeatureList>
      <ActionButton onClick={action}>Buy Now</ActionButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
    transform: translateY(-10px);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  margin-bottom: 20px;
`;

const Price = styled.p`
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin: 10px 0;
  color: #333;
`;

const Title = styled.h4`
  font-size: 24px;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin: 10px 0;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  text-align: center;
  margin: 20px 0;
`;

const FeatureList = styled.div`
  margin-bottom: 30px;
`;

const Feature = styled.div`
  font-size: 16px;
  color: #555;
  display: flex;
  align-items: center;
  margin: 10px 0;
`;

const Check = styled.div`
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 50%;
  margin-right: 10px;
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 12px;
  font-size: 18px;
  font-weight: bold;
  background-color: #00c6b7;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover {
    background-color: #009e8e;
  }
`;

